import { styled } from 'styled-components';
export const AlertBannerContent = styled.div.withConfig({
  displayName: "AlertBannerContent",
  componentId: "asurion-ui-react__sc-zyvym6-0"
})(["align-items:flex-start;display:flex;width:100%;"]);